const numberHelpers = {
    formatPrice: function (input) {
        let price = parseFloat(input.toString() || "0").toFixed(2)
        price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        return price
    },

};

export default numberHelpers;